/**
 * @file
 * Combined Header Scroll Animation and Height Behavior for Drupal.
 */

(function (Drupal) {
  /**
   * Header behavior combining scroll effects and height tracking.
   */
  Drupal.behaviors.headerBehavior = {
    attach(context, settings) {
      // Target both possible selectors
      const headerSelectors = ['.header[role="banner"]'];
      let header = null;

      // Find the header element
      for (const selector of headerSelectors) {
        header = context.querySelector(selector);
        if (header) break;
      }

      if (!header) {
        return;
      }

      // Prevent multiple initializations
      if (header.headerInitialized) {
        return;
      }
      header.headerInitialized = true;

      const headerElement = header;

      // Function to update the CSS variable with header height
      const updateHeaderHeight = () => {
        const styles = window.getComputedStyle(headerElement);
        const marginTop = parseFloat(styles.marginTop) || 0;
        const marginBottom = parseFloat(styles.marginBottom) || 0;
        const paddingTop = parseFloat(styles.paddingTop) || 0;
        const paddingBottom = parseFloat(styles.paddingBottom) || 0;

        // offsetHeight includes padding and border, but not margins
        const totalHeight =
          headerElement.offsetHeight + marginTop + marginBottom;

        document.documentElement.style.setProperty(
          '--header-height',
          `${totalHeight}px`,
        );

        // Optional: Set individual height components as CSS variables
        document.documentElement.style.setProperty(
          '--header-height-content',
          `${headerElement.offsetHeight}px`,
        );
        document.documentElement.style.setProperty(
          '--header-height-with-margins',
          `${totalHeight}px`,
        );
      };

      // Function to handle scroll class toggle
      const updateScrollClass = () => {
        const scrolled = window.scrollY > 50;

        if (scrolled) {
          headerElement.classList.add('scrolled');
        } else {
          headerElement.classList.remove('scrolled');
        }
      };

      // Combined scroll handler
      const handleScroll = () => {
        updateScrollClass();
        // Only update height on resize, not on every scroll to prevent layout shifts
      };

      // Initial setup
      updateHeaderHeight();
      updateScrollClass();

      // Create debounced functions using Drupal.debounce
      const debouncedResize = Drupal.debounce(updateHeaderHeight, 100);
      const debouncedScroll = Drupal.debounce(handleScroll, 8);

      // Add event listeners
      window.addEventListener('resize', debouncedResize);
      window.addEventListener('scroll', debouncedScroll);

      // Store cleanup references
      headerElement.headerCleanup = {
        resize: debouncedResize,
        scroll: debouncedScroll,
      };
    },

    detach(context, settings, trigger) {
      if (trigger === 'unload') {
        const headerSelectors = ['.header[role="banner"]', 'header.header'];

        for (const selector of headerSelectors) {
          context.querySelectorAll(selector).forEach((header) => {
            if (header.headerCleanup) {
              window.removeEventListener('resize', header.headerCleanup.resize);
              window.removeEventListener('scroll', header.headerCleanup.scroll);
              delete header.headerCleanup;
              delete header.headerInitialized;
            }
          });
        }
      }
    },
  };
})(Drupal);
